export default __webpack_public_path__ + "static/media/Image-1.16747d2d.png";